import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("hr_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    if (
      error.response?.status === 401 &&
      orig &&
      !orig._retried &&
      !String(orig.url).includes("/auth/")
    ) {
      orig._retried = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        const { data } = await refreshing;
        refreshing = null;
        if (data?.access_token) localStorage.setItem("hr_token", data.access_token);
        return api(orig);
      } catch (e) {
        refreshing = null;
        localStorage.removeItem("hr_token");
      }
    }
    return Promise.reject(error);
  }
);

export const formatApiError = (e) => {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d
      .map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x)))
      .join(", ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
};

export default api;
